import MobileBackPage from './mobile-back-page'

export { MobileBackPage }
